<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="customer-modal-proposed" :title="`Propuesta creada para ${customer?.name}`" subtitle="Cambiar estado del cliente a propuesta enviada" bodyClass="container-md vstack gap-5">
		<template #body>
			<div class="vstack gap-5">
				<CommonFormInputCustomProposal :proposal="proposal" :customer="customer" title="Link de la propuesta" placeholder="Sin dirección válida" />
				<CommonFormInputTextarea v-model="form.observations" title="Observaciones" subtitle="Opcional" placeholder="Ingrese una observacion" />
			</div>
		</template>
		<template #footer>
			<a href="javascript:void(0);" class="link-danger" data-bs-dismiss="offcanvas">No cambiar estado</a>
			<button type="button" class="btn rounded-pill btn-primary" :disabled="submitting" @click="submit">Cambiar estado</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
	import { Modal, Offcanvas } from 'bootstrap';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CustomerRepository from '@/repositories/modules/Customer';

	export default {
		setup(props) {
			const { submitting, catchError } = composableForm();
			const instance = getCurrentInstance();
			const offcanvas = ref(null);
			const customer = ref(null);
			const proposal = ref(null);

			const form = reactive({
				status: 'proposed',
				observations: null
			});

			const closeOpenOffcanvas = () => {
				if(document.querySelector('.offcanvas.show')) {
					var offcanvasShowed = Offcanvas.getInstance(document.querySelector('.offcanvas.show'));
					offcanvasShowed.hide();
				}

				if(document.querySelector('.modal.show')) {
					var modalShowed = Modal.getInstance(document.querySelector('.modal.show'));
					modalShowed.hide();
				}
			}

			const customerProposed = (dataCustomer = null, dataProposal = null) => {
				closeOpenOffcanvas();
				customer.value = dataCustomer;
				proposal.value = dataProposal;
				form.observations = null;
				offcanvas.value.offcanvas.show();
			}

			const submit = async () => {
				submitting.value = true;

				await CustomerRepository.history(customer.value.id, form).then((response) => {
					offcanvas.value.offcanvas.hide();
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const closed = () => {
				if(instance.proxy?.$redirect && typeof instance.proxy.$redirect === 'function')
					instance.proxy.$redirect();
			}

			onMounted(() => {
				if(instance) instance.appContext.config.globalProperties.$customerProposed = customerProposed;

				document.getElementById('customer-modal-proposed').addEventListener('hidden.bs.offcanvas', () => {
					closed();
				});
			});

			return { submitting, customer, proposal, offcanvas, submit, form };
		}
	}
</script>